<template>
  <div>
    <v-card-text
      v-if="
        selectedApplication.allCoursesApproved"
      class="mt-0 pa-0 mb-2"
    >
      <MessageBox>
        <h5>DENNA PERSON VERKAR HA EN KOMPLETT GRUNDUTBILDNING</h5>
        <p class="fontsize-14">
          Dokumenten verkar visa på att personen har en komplett grundutbildning. Du kan godkänna grundutbildningen genom att klicka på knappen.
        </p>
        <div>
          <v-btn
            style="width: auto"
            v-if="!certificateIsCreated"
            outlined
            @click="$emit('confirm-education', {
                edModal: true,
                edMode: 'create',
                addTitle: 'Godkänn grundutb.'
            })"
            :disabled="!approvedStateByCompany || !(selectedApplication && selectedApplication.allCoursesApproved)"
          >
            <v-icon>$sl-add</v-icon>Godkänn grundutb.
          </v-btn>
          <v-btn
            style="width: auto"
            v-else-if="!certificateIsApproved && certificateIsCreated && showMode"
            :disabled="certificateIsApproved && showMode != true ? true : false"
            outlined
            @click="$emit('confirm-education', {
                edModal: true,
                edMode: 'approve',
                addTitle: showMode ? 'BEKRÄFTA GODKÄNNANDE AV GRUNDUTB.' : 'GODKÄNN GRUNDUTBILDNING'
            })"
          >
            Bekräfta godk. av GU</v-btn>
          <v-btn
            style="width: auto"
            v-else
            outlined
            @click="$emit('confirm-education', {edModal: true})"
            disabled
          >
            <v-icon></v-icon>{{ showMode ? 'Bekräfta godk. av GU' : 'Godkänn grundutb.' }}
          </v-btn>
        </div>
      </MessageBox>
    </v-card-text>

    <v-card-text class="ma-0 pa-0">
      <v-data-table
        :headers="[
            {
              text: 'Kurs',
              sortable: false,
              filterable: false,
              value: 'courseName',
              width: '200'
            },
            {
              text: 'Kod',
              sortable: false,
              filterable: false,
              value: 'courseCode',
              width: '120'
            },
            {
              text: 'Källa',
              sortable: false,
              filterable: false,
              value: 'source',
              width: '120'
            },
            {
              text: 'OCR-Resultat*',
              sortable: false,
              filterable: false,
              value: 'ocrApproved',
              width: '120'
            },
            {
              text: 'Enligt Lärling',
              sortable: false,
              filterable: false,
              value: 'apprenticeApproved',
              width: '120'
            },
            {
              text: 'Regionärs Bedömning',
              sortable: false,
              filterable: false,
              value: 'approved',
              width: '120'
            }
          ]"
        :items="getItems"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        hide-default-footer
        item-key="id"
        class="small"
      >

        <template
          slot="item.ocrApproved"
          slot-scope="props"
        >
          <div>
            <template v-if="props.item.ocrApproved">
              <span class="Oval green"></span> <span>Godkändx</span>
            </template>
            <template v-else>
              <span class="missing">(saknas)</span>
            </template>
          </div>
        </template>

        <template
          slot="item.apprenticeApproved"
          slot-scope="props"
        >
          <div>
            <template v-if="props.item.apprenticeApproved">
              <span class="Oval green"></span> <span>Godkänd</span>
            </template>
            <template v-else>
              <span class="missing">(saknas)</span>
            </template>
          </div>
        </template>

        <template
          slot="item.approved"
          slot-scope="props"
        >
          <v-select
            filled
            class="result"
            :disabled="false"
            :class="props.item.approved == true ? 'approve' : props.item.approved == false ? 'notApprove' : 'missing'"
            :items="selectItems"
            v-model="props.item.approved"
            item-text="name"
            item-value="approved"
          >
          </v-select>
        </template>

        <template
          slot="item.source"
          slot-scope="props"
        >
          <div>
            {{ get(props, 'item.source.value', '') }}
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <v-row>
      <v-col cols="6">
        <template v-if="certificateIsApproved || certificateIsCreated">
          <strong>Historik</strong>
          <div v-if="certificateIsCreated">
            <span>{{ get(selectedApplication,"education.basicEducationCertificate.createdAt", null) | date }}</span>:
            <span> Grundutbildning godkänd</span>
            <span v-if="get(selectedApplication, 'education.basicEducationCertificate.createdBy', null)">
              (<a @click="showUser(get(selectedApplication, 'education.basicEducationCertificate.createdById'))">{{ get(selectedApplication, 'education.basicEducationCertificate.createdBy.firstName', '') }} {{ get(selectedApplication, 'education.basicEducationCertificate.createdBy.lastName', '') }}</a>)
            </span>
          </div>
          <div v-if="certificateIsApproved">
            <span>{{ get(selectedApplication,"education.basicEducationCertificate.approvedAt", null) | date }}</span>:
            <span> Godkännande av grundutbildning bekräftad</span>
            <span>
              (<a @click="showUser(get(selectedApplication, 'education.basicEducationCertificate.approvedById'))">{{ get(selectedApplication, 'education.basicEducationCertificate.approvedBy.firstName', '') }} {{ get(selectedApplication, 'education.basicEducationCertificate.approvedBy.lastName', '') }}</a>)
            </span>
          </div>
        </template>
      </v-col>
      <v-col cols="6">
        *OCR-resultat (“optical character recognition”) uppnås genom maskinläsning av betygsfilerna. OCR-tekniken har
        varierande träffsäkerhet. Var därför vänlig och förlita dig inte helt på OCR-resultatet utan kontrollera också
        att det stämmer.
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import get from 'lodash/get'
import API from '@/services/api'
import MessageBox from '@/components/common/MessageBox.vue'

export default {
  name: 'ApplicationEducationEdit',

  props: {
    certificateIsCreated: {
      type: Boolean,
      required: true
    },

    certificateIsApproved: {
      type: Boolean,
      required: true
    },

    getItems: {
      type: Array,
      required: true
    },

    itemsPerPage: {
      type: Number,
      required: true
    },

    selectItems: {
      type: Array,
      required: true
    },
    reform: {
      type: String,
      default: null
    }
  },

  components: {
    MessageBox
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'approvedStateByCompany']),
    ...mapGetters('app', ['isLoading'])
  },

  methods: {
    get,

    save() {
      // @vuese
      //-Update Application
      this.editing = true
      const selectedReform = this.reform === 'Gy11' ? null : this.reform
      API.updateApplication(this.selectedApplication.id, {
        data: {applicationCourses: this.getItems, reform: selectedReform}
      })
        .then(response => {
          //- Update Application in store
          this.$emit('saved')
        })
        .catch(error => {
          this.$events.fire('showError', 'Kurser kan inte ändras')
          console.log('There was an error:', error)
        })
    },

    cancel() {
      console.log('Cancel clicked')
      const { reform } = get(this, 'getItems', [])[0] || {}
      this.$emit('on-cancel', !reform ? 'Gy11' : reform)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>